import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { DrawerContext } from './drawer-context';
import { ModalContext } from './modal-context';
import ProductCustomizer from './product-customizer';
import ThreekitPlayer from './threekit-components/threekit-player';
import { ThreekitContext } from './threekit-context';
import BackgroundContainer from './components/background-container';
import closeCustomizer from './components/util/closeCustomizer';

export default (element, data) => {
  const RenderProductCustomizer = () => {
    const [isOpen, setIsOpen] = useState(false);

    // Helps close the customizer when the back button is pressed
    useEffect(() => {
      window.addEventListener('popstate', closeCustomizer);
      return () => window.removeEventListener('popstate', closeCustomizer);
    }, []);

    useEffect(() => {
      function handleOpenCustomizer() {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('customizerOpen', 'true');
        document.querySelector('body').classList.add('customizer-open');
        window.history.pushState(
          { id: 1 },
          null,
          `?${searchParams.toString()}`,
        );

        setIsOpen(true);
        window.zE('messenger', 'hide');
      }

      function handleCloseCustomizer() {
        const customizerSection = document.querySelector(
          "[data-section='product-customizer']",
        );
        if (customizerSection) {
          // Add div with the id of player back to the
          // section so we can re-render the player
          document.querySelector('#player').remove();
          const player = document.createElement('div');
          player.id = 'player';
          player.classList.add('w-screen', 'h-full');
          customizerSection.appendChild(player);
          customizerSection.classList.add('hidden');
        }
        const currentUrl = window.location.href;
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('customizerOpen');
        searchParams.delete('cartUpdate');
        document.querySelector('body').classList.remove('customizer-open');
        const newUrl = `${currentUrl.split('?')[0]}?${searchParams.toString()}`;
        window.history.replaceState({}, '', newUrl);

        setIsOpen(false);
        window.zE('messenger', 'show');
      }

      document.addEventListener('openCustomizer', handleOpenCustomizer);
      document.addEventListener('closeCustomizer', handleCloseCustomizer);

      return () => {
        document.removeEventListener('closeCustomizer', handleCloseCustomizer);
        document.removeEventListener('openCustomizer', handleOpenCustomizer);
      };
    }, []);

    if (!isOpen) {
      return null;
    }

    return (
      <ThreekitContext data={data}>
        <DrawerContext data={data}>
          <ModalContext>
            <BackgroundContainer />
            <div className="fixed top-0 h-[61.5dvh] laptop:h-screen">
              <ThreekitPlayer />
              <ProductCustomizer />
            </div>
          </ModalContext>
        </DrawerContext>
      </ThreekitContext>
    );
  };

  const init = () => {
    render(<RenderProductCustomizer {...data} />, element);
  };

  init();
};
